import ViewMobDetails from "./ViewMobDetails";

export default ViewMobDetails;